import React from 'react'
import { useHistory, Link } from 'react-router-dom'
import { useStoreView } from 'hooks/useStoreView'
import { Label } from 'components/Label'
import { ListPages } from 'lib/core/services/gtm'
import { ProductPrice, useProductStatus } from 'lib/modules/catalog'
import { ProductData } from 'lib/types'
import { SofiaWrapper, LivWrapper, PriceWrapper, GeneralContainer } from './styled'
import { useGTM } from 'lib/core/hooks'
import { Variants } from './components/Variants'
import { Actions } from './components/Actions'

interface Props {
  product: ProductData
  listPage: ListPages
}

export const ProductCard = ({ product, listPage }: Props) => {
  const { isSofiaAndGrace } = useStoreView()
  const { image, name, price, sku, customAttribute, getUrlPath, configurableOptions } = product
  const history = useHistory()
  const [packageType] = customAttribute?.package ?? []
  const [brand] = customAttribute?.manufacturer ?? []
  const [availableFrequencies] = customAttribute?.available_frequencies ?? []
  const [subscriptionsEligible] = customAttribute?.subscription_eligible ?? []
  const isSubscriptionEligible = subscriptionsEligible !== 'No'
  const hasSubscriptions = Boolean(isSubscriptionEligible && availableFrequencies)
  const imageUrl = image?.default?.url
  const productUrlPath = getUrlPath()
  const { getIsSale } = useProductStatus(product)
  const isSale = getIsSale()
  const StyledWrapper = isSofiaAndGrace ? SofiaWrapper : LivWrapper
  const { triggerProductClick } = useGTM()
  const callGTM = () => {
    triggerProductClick({ sku, name, listPage })
  }

  const handleClick = () => {
    callGTM()
    history.push(productUrlPath)
  }

  return (
    <GeneralContainer>
      <StyledWrapper>
        {hasSubscriptions && (
          <span className='subscription-label'>Schedule & Save 10%</span>
        )}
        {isSale && <Label isSale position={1}>Sale</Label>}
        <Link onClick={callGTM} to={productUrlPath} className={hasSubscriptions ? 'image__wrapper has-label' : 'image__wrapper'}>
          <img src={imageUrl} alt={name} width='135' height='135' />
        </Link>
        <span className='brand'>{brand}</span>
        <Link className='product-name' onClick={callGTM} to={productUrlPath}>{name}</Link>
        <Variants
          options={configurableOptions}
          productPath={productUrlPath}
        />
        <PriceWrapper
          isLivBrite={!isSofiaAndGrace}
        >
          <ProductPrice renderOldPrice price={price} />
          {isSofiaAndGrace && (<div>{packageType ? `per ${packageType}` : 'per bag'}</div>)}
        </PriceWrapper>
        <Actions
          handleClick={handleClick}
          configurableOptions={configurableOptions}
          sku={sku}
        />
      </StyledWrapper>
    </GeneralContainer>
  )
}
